export const checkCoupon = (coupon, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'get',
    apiPath: `coupon/${coupon}`,
    cancelToken
  })
)
